import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { UserService } from 'src/app/services/user.service';

@Component({
	selector: 'app-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
	length8 = false;
	mayusExist = false;
	minusExist = false;
	numbersExist = false;
	startPassword = false;
	formRegister: FormGroup;
	tempCompanyRoles: any;
	messageError: string = "";
	serverImagesUrl = 'https://s3.amazonaws.com/rrhh-images/company/logos/';
	sending = false;

	constructor(
		private userService: UserService,
		private toastService: ToastrService,
		private router: Router
	) {

		this.formRegister = new FormGroup({
			mail: new FormControl('',
				[
					Validators.required
				]
			),
			pass: new FormControl('',
				[
					Validators.required
				]
			),
			pais: new FormControl(null,
				[
					Validators.required
				]
			)
		});
	}

	ngOnInit() {
	}

	checkPassword(event: any) {
		var value = event.target.value;
		this.startPassword = true;
		this.length8 = value.length >= 8;
		this.mayusExist = /[A-Z]/.test(value);
		this.minusExist = /[a-z]/.test(value);
		this.numbersExist = /[0-9]/.test(value);
	}

	sendDataUser() {
		this.sending = true;
		this.userService.register(this.formRegister.value).subscribe({
			next: (response: ResponseObject) => {
				this.sending = false;
				this.toastService.success("El usuario fue registrado correctamente!");
				localStorage.setItem('jwt', response.data.token);
				localStorage.setItem('companyRoles', response.data.companyRoles);
				this.tempCompanyRoles = response.data.companyRoles;
				this.imageUrlRefractor();
				var success = response.data;
				var currentUser =
				{
					id: success.id,
					firstName: success.firstName,
					lastName: success.lastName,
					mail: success.email,
					imageUrl: 'https://s3.amazonaws.com/rrhh-images/user/image/' + success.image,
					country: success.country,
					defaultCompany: success.defaultCompany,
					services: success.services,
					alphanumericId: success.alphanumericId,
					companyRoles: this.tempCompanyRoles,
					countryId: success.countryId,
					canAdminUsers: success.canAdminUsers,
					canAdminCompanies: success.canAdminCompanies,
					seller: success.seller,
					adviser: success.adviser,
					validated: success.validated,
					balance: success.balance,
					currency: success.currency,
					passOk: success.passOk,
					associate: success.associate,
					admin: success.admin,
					directAdviser: success.directAdviser,
					credit: success.credit,
					companiesReservedBalance: success.companiesReservedBalance,
					allRolesInCompanies: [],
					contadorGT: success.contadorGT,
					userPartner: success.userPartner
				};
				localStorage.setItem('user', JSON.stringify(currentUser));
				localStorage.setItem('allServices', JSON.stringify(currentUser.services));
				if (currentUser.companyRoles.length > 0) {
					this.router.navigate(['select-company']);
				}
			},
			error: (error: HttpErrorResponse) => {
				this.sending = false;
				this.toastService.error(error.error.message);
				this.messageError = error.error.message;
			}
		})
	}

	imageUrlRefractor() {
		for (var i = 0; i < this.tempCompanyRoles.length; i++) {
			var companyLogo = this.tempCompanyRoles[i].companyLogo;
			var newCompanyLogo = "/images/company-avatar2.png";
			if (companyLogo !== null) {
				newCompanyLogo = this.serverImagesUrl + companyLogo;
			}
			this.tempCompanyRoles[i].companyLogo = newCompanyLogo;
		}
	};
}
